import { BrandCard } from "@/components/marcas/BrandCard";
import { useFeaturedBrandsPublic } from "@/hooks/useFeaturedBrands";
import { cn } from "@/lib/utils";

// Lojas ocultadas no mobile (< sm) para manter a grade parada (count par).
const MOBILE_HIDDEN_SLUGS = ["webcontinental"];

export const FeaturedBrandsStrip = () => {
  const { data: brands } = useFeaturedBrandsPublic();
  // Enquanto carrega, reserva o espaço da grade para a página não "pular".
  if (brands === undefined) return (
    <section className="pb-12 md:pb-16" aria-hidden="true">
      <div className="container">
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {Array.from({ length: 15 }).map((_, i) => <li key={i} className="h-[220px] animate-pulse rounded-lg bg-muted" />)}
        </ul>
      </div>
    </section>
  );
  if (brands.length === 0) return null;

  return (
    <section className="pb-12 md:pb-16" aria-label="Lojas em destaque">
      <div className="container">
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {brands.map((brand) => (
            <li
              key={brand.id}
              className={cn(
                "min-w-0",
                MOBILE_HIDDEN_SLUGS.includes(brand.slug) && "hidden sm:block"
              )}
            >
              <BrandCard brand={brand} showFeaturedBadge={false} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
